import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';

export interface PasswordResetResponse {
  success: boolean;
}

export interface PasswordResetErrorResponse {
  message: string;
}

export enum PasswordResetResult {
  Success,
  RateLimited,
  Error
}

@Injectable({
  providedIn: 'root'
})
export class PasswordResetService {

  constructor(private httpClient: HttpClient) {}

  /**
   * Request a password reset email for the given email address.
   * Note: The backend always returns success even if the email doesn't exist
   * (security measure to prevent email enumeration).
   */
  public async requestPasswordReset(email: string): Promise<PasswordResetResult> {
    const url = `${environment.serverAddress}/api/public/vendor/password-reset/request`;

    try {
      await firstValueFrom(
        this.httpClient.post<PasswordResetResponse>(url, { email })
      );
      return PasswordResetResult.Success;
    } catch (error) {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 429) {
          return PasswordResetResult.RateLimited;
        }
      }
      return PasswordResetResult.Error;
    }
  }
}
